var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-new": false,
          "show-print": _vm.readOnlyView,
          "show-delete": false,
          "show-save": _vm.isSaveButton && !_vm.readOnlyView,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _vm.entity
              ? _c("receipt-payment-side-menu", {
                  ref: "sideMenu",
                  model: {
                    value: _vm.entity,
                    callback: function ($$v) {
                      _vm.entity = $$v
                    },
                    expression: "entity",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column" },
          [
            _vm.entity
              ? _c("router-view", {
                  key: _vm.$route.fullPath,
                  ref: "currentChild",
                  attrs: {
                    "disable-change": _vm.entity.isNew,
                    "is-tiled": false,
                    "route-name": _vm.$route.name,
                    "read-only-view": _vm.readOnlyView,
                    "can-print-statement": _vm.canPrintStatement,
                  },
                  on: {
                    printStatement: function ($event) {
                      return _vm.print1()
                    },
                  },
                  model: {
                    value: _vm.entity,
                    callback: function ($$v) {
                      _vm.entity = $$v
                    },
                    expression: "entity",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "confirm-modal",
        {
          attrs: {
            active: _vm.isConfirmModalActive,
            "ok-text": "Save & Print",
            "cancel-text": "Print",
            "close-text": "Close",
            "show-close": true,
          },
          on: {
            "update:active": function ($event) {
              _vm.isConfirmModalActive = $event
            },
            ok: function ($event) {
              return _vm.saveEntity("ok")
            },
            cancel: function ($event) {
              return _vm.saveEntity("print")
            },
            close: function ($event) {
              return _vm.saveEntity("close")
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Do you want to Save and Print?"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v(" This will save your selected Receipt Payment and Print. "),
          ]),
        ]
      ),
      _c(
        "unsaved-modal",
        {
          attrs: { active: _vm.isUnsavedModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isUnsavedModalActive = $event
            },
            close: function ($event) {
              return _vm.closeModal()
            },
            skipSave: function ($event) {
              return _vm.skipSave()
            },
            saveContinue: function ($event) {
              return _vm.saveContinue()
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Unsaved Changes"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v("There are unsaved changes. Please select action below"),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }